export interface TimelineEvent {
  year: string;
  event: string;
}

export interface ProfileInfo {
  name: string;
  englishName: string;
  avatar: string;
  birthday: string;
  birthplace: string;
  profession: string[];
  representativeWorks: string[];
  bio: string;
  timeline: TimelineEvent[];
}

export const profileInfo: ProfileInfo = {
  name: '张柏芝',
  englishName: 'Cecilia Cheung',
  avatar: 'https://readdy.ai/api/search-image?query=elegant%20asian%20actress%20portrait%20headshot%2C%20soft%20studio%20lighting%2C%20navy%20blue%20background%2C%20professional%20magazine%20cover%20photography%2C%20warm%20skin%20tone%2C%20graceful%20expression&width=640&height=640&seq=profile-avatar-01&orientation=squarish',
  birthday: '1980年5月24日',
  birthplace: '中国香港',
  profession: ['演员', '歌手'],
  representativeWorks: ['花都浮梦', '长河入海', '光影之间'],
  bio: '张柏芝，华语影视女演员，出道以来参演多部电影与电视剧作品，凭借多样化的角色塑造与细腻的表演风格获得广泛关注，是深受观众喜爱的实力派演员之一。',
  timeline: [
    { year: '1999', event: '正式进入演艺圈，出演首部电影作品，崭露头角。' },
    { year: '2003', event: '凭借多部卖座电影奠定一线女演员地位，获得多项提名。' },
    { year: '2012', event: '转型挑战多元角色，在电视剧领域持续发力。' },
    { year: '2020', event: '回归大银幕，参演多部口碑作品，演技获认可。' },
    { year: '2026', event: '新作陆续上映，持续活跃于影视创作一线。' },
  ],
};